// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD2UJnLv3gca2t1-P4Oiy9wOuijllqbnXc",
  authDomain: "notes-app-c0d33.firebaseapp.com",
  projectId: "notes-app-c0d33",
  storageBucket: "notes-app-c0d33.appspot.com",
  messagingSenderId: "110834899164",
  appId: "1:110834899164:web:9490d24222fe1dad163c19",
  measurementId: "G-DXQ2LHLH1E"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);